import React from "react"
import { Box } from "@mui/material"
import NumSearchesBlock from "Pages/ReportsAlerts/Reports/@components/NumSearchesBlock"


export default function numSearchColumn() {
	return {
		name: "numSearches", label: "Search numbers",
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<NumSearchesBlock numSearches={value}/>
			</Box>
		}
	}
}